import React from 'react';
import { Calendar, ArrowRight } from 'lucide-react';
import { useNews } from '../../context/CMSContext';

const NewsSection: React.FC = () => {
  const news = useNews();
  if (!news.length) return null;

  return (
    <section id="news" className="py-24 bg-white">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-12 gap-6">
          <div className="max-w-2xl">
            <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">最新消息與市場資訊</h2>
            <div className="w-16 h-1 bg-gold-600 mb-6"></div>
            <p className="text-slate-600">掌握香港工商舖市場的第一手資訊，助您精準佈局。</p>
          </div>
          <span className="text-gold-600 font-bold flex items-center gap-2">
            查看全部文章 <ArrowRight className="w-5 h-5" />
          </span>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {news.map((item) => (
            <article
              key={item.id}
              className="flex flex-col lg:flex-row gap-6 p-4 rounded-2xl border border-slate-100 hover:border-gold-200 hover:shadow-lg transition-all group"
            >
              <div className="lg:w-1/3 h-48 lg:h-auto overflow-hidden rounded-xl">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="lg:w-2/3 flex flex-col justify-center py-2">
                <div className="flex items-center gap-4 mb-3">
                  <span className="text-[10px] font-bold uppercase tracking-widest text-gold-600 bg-gold-50 px-2 py-1 rounded">
                    {item.category}
                  </span>
                  <div className="flex items-center gap-1 text-slate-400 text-xs">
                    <Calendar className="w-3 h-3" />
                    <span>{item.date}</span>
                  </div>
                </div>
                <h3 className="text-xl font-bold text-slate-900 mb-3 group-hover:text-gold-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-slate-500 text-sm leading-relaxed mb-4">{item.summary}</p>
                <span className="text-slate-900 font-semibold text-sm inline-flex items-center gap-1 group/link">
                  閱讀更多 <ArrowRight className="w-4 h-4 transition-transform group-hover/link:translate-x-1" />
                </span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default NewsSection;
